export enum ModuleElementType {
  module = 'Module',
  section = 'Section',
  step = 'Step',
  site = 'Site'
}
